/* Initialize wp and acf variables to prevent console errors.
 * 
 * Errors "wp is not defined" and "acf is not defined" were happening because enqueued
 * scripts are being deferred by the function thunderberg_defer_parsing_of_js(), but
 * embedded scripts are not.
 * 
 * This script is specifically not deferred and enqueued at the top so the wp and acf
 * variables are always initialized.
 */
window.wp = window.wp || {};
window.acf = window.acf || {};